var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-recommend" }, [
    _c("h3", { staticClass: "recommend-title" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_TITLE")) +
          "\n\t"
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recommend-subtitle" }, [
      _vm._v(
        "\n\t\t" +
          _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_SUBTITLE")) +
          "\n\t"
      )
    ]),
    _vm._v(" "),
    _c("ul", { staticClass: "recommend-list dp-f" }, [
      _c("li", { staticClass: "rd-block" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "rd-block-text" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK1_TEXT")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-name" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK1_USER")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-company" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK1_COMPANY")
              ) +
              "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rd-block" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("p", { staticClass: "rd-block-text" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK2_TEXT")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-name" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK2_USER")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-company" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK2_COMPANY")
              ) +
              "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rd-block" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("p", { staticClass: "rd-block-text" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK3_TEXT")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-name" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK3_USER")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-company" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK3_COMPANY")
              ) +
              "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "rd-block" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("p", { staticClass: "rd-block-text" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK4_TEXT")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-name" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK4_USER")) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "rd-block-company" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("EAGLE_LANDING_RECOMMEND_BLOCK4_COMPANY")
              ) +
              "\n\t\t\t"
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rd-block-logo" }, [
      _c("img", {
        attrs: { src: require("../images/svg/uisdc-logo.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rd-block-logo" }, [
      _c("img", {
        attrs: { src: require("../images/svg/xueui-logo.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rd-block-logo" }, [
      _c("img", {
        attrs: { src: require("../images/svg/meiya-logo.svg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rd-block-logo" }, [
      _c("img", {
        attrs: { src: require("../images/svg/xijian-logo.svg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }